import React, { PropsWithChildren, useContext, useEffect } from 'react'
import { InformationalError } from '@aserto/console-common'
import { useShowError } from '@aserto/console-common'

import { Configurations } from '../../../common/types'
import { useInternalConfig } from '../../api/internal'

const emptyConfig = {
  oidcClientId: '',
  oidcDomain: '',
  authenticationType: '',
  readOnly: false,
  configs: [],
}
const configContext = React.createContext<Configurations>(emptyConfig)

export const useConfig = () => {
  const config = useContext(configContext)
  if (config === emptyConfig) {
    throw 'Config must be retrieved in the context of a <ConfigProvider>'
  }

  return config
}

const ConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { data: config, error } = useInternalConfig()
  const showError = useShowError()

  useEffect(() => {
    if (!!error) {
      showError(
        new InformationalError(
          'This may be a temporary error. Please try reloading this page. If the error persists, contact support@aserto.com.',
          'Looks like we are having issues with our services :('
        )
      )
    }
  }, [error, showError])

  return !config ? null : <configContext.Provider value={config}>{children}</configContext.Provider>
}

export default ConfigProvider
